module.exports = "/images/hausa.svg?323bd82e40b7d2a12eeb7f8b36a55e96";